export default "__VITE_ASSET__BgHEdfuB__"